import React, { useState, useRef, useEffect, useCallback } from 'react';

const LANG_CONFIG = {
  'zh-HK': { sys: '用繁體中文回答，語氣友善，回答簡潔清晰。', name: 'EC 小助手', welcome: '你好！我是 EC 小助手 ✈️\n有什麼旅遊問題我可以幫你？', off: '你只回答與旅遊相關的問題，包括景點推薦、旅遊路線、交通、住宿、簽證、飲食、文化、預算、天氣、匯率與換錢、電話卡/eSIM、行李與轉機、旅遊保險、當地禮儀、緊急求助、購物與退稅。凡是與出行有關的實用問題一律視為旅遊相關。只有明顯與旅遊無關的問題（例如寫詩、寫程式、功課），才請禮貌地說明你只回答旅遊問題。', factCheck: '簽證、開放時間、票價等會隨時變動的資訊，回答時要提醒使用者以官方最新公告為準，不要當作絕對事實陳述。天氣問題屬於旅遊範圍，絕不可拒答：你沒有即時預報，所以請提供該地點該月份的一般氣候（氣溫、降雨、穿著建議），並只用整個月份的大概範圍（例如「約 15–22°C」），不要逐日列出數字或降雨機率，並註明這不是即時預報，精確預報請查當地氣象機構。', disclaimer: '資訊僅供參考，簽證/開放時間/價錢請自行核實' },
  'zh-CN': { sys: '用简体中文回答，语气友好，回答简洁清晰。', name: 'EC 小助手', welcome: '你好！我是 EC 小助手 ✈️\n有什么旅游问题我可以帮你？', off: '你只回答与旅游相关的问题，包括景点推荐、旅游路线、交通、住宿、签证、饮食、文化、预算、天气、汇率与换钱、电话卡/eSIM、行李与转机、旅游保险、当地礼仪、紧急求助、购物与退税。凡是与出行有关的实用问题一律视为旅游相关。只有明显与旅游无关的问题（例如写诗、写程序、作业），才请礼貌地说明你只回答旅游问题。', factCheck: '签证、开放时间、票价等会随时变动的资讯，回答时要提醒使用者以官方最新公告为准，不要当作绝对事实陈述。天气问题属于旅游范围，绝不可拒答：你没有实时预报，所以请提供该地点该月份的一般气候（气温、降雨、穿着建议），并只用整个月份的大概范围（例如“约 15–22°C”），不要逐日列出数字或降雨概率，并注明这不是实时预报，精确预报请查当地气象机构。', disclaimer: '信息仅供参考，签证/开放时间/价钱请自行核实' },
  'en':    { sys: 'Reply in English. Be friendly and concise.', name: 'EC Assistant', welcome: 'Hi! I\'m EC Assistant ✈️\nHow can I help with your travel plans?', off: 'Answer travel-related questions: attractions, itineraries, transport, accommodation, visas, food, culture, budget, weather, currency exchange, SIM/eSIM, luggage and transfers, travel insurance, local etiquette, emergencies, shopping and tax refunds. Treat any practical trip-related question as travel-related. Politely decline only clearly unrelated topics (e.g. poems, coding, homework).', factCheck: 'For information that changes over time (visas, opening hours, ticket prices), remind the user to verify against official up-to-date sources rather than stating it as certain fact. Weather questions are travel questions and must never be declined: you have no live forecast, so give the typical climate for that place and month (temperature, rain, what to pack) as a rough monthly range only (e.g. "about 15–22°C"), never day-by-day figures or rain percentages, and note it is not a live forecast.', disclaimer: 'For reference only — verify visas/hours/prices independently' },
  'ja':    { sys: '日本語で回答してください。親切で簡潔に。', name: 'ECアシスタント', welcome: 'こんにちは！ECアシスタントです ✈️\n旅行について何でもお聞きください！', off: '観光地、旅程、交通、宿泊、ビザ、食事、文化、予算、天気、両替、SIM/eSIM、荷物・乗り継ぎ、旅行保険、現地マナー、緊急時、買い物・免税など、旅行に関する質問に回答します。出発前後の実用的な質問は旅行に関するものとして扱ってください。明らかに無関係な質問（詩、プログラミング、宿題など）のみ丁重にお断りください。', factCheck: 'ビザ、開館時間、料金など変動する可能性がある情報については、断定せず公式の最新情報を確認するよう案内してください。天気の質問は旅行の質問であり、断ってはいけません。リアルタイムの予報はないため、その場所・月の一般的な気候（気温・降水・服装）を答え、月単位のおおよその範囲のみ（例：「約15〜22°C」）で、日ごとの数値や降水確率は出さず、リアルタイム予報ではない旨を添えてください。', disclaimer: '情報は参考程度に。ビザ・開館時間・料金は必ずご自身でご確認ください' },
  'ko':    { sys: '한국어로 답변하세요. 친절하고 간결하게.', name: 'EC 어시스턴트', welcome: '안녕하세요! EC 어시스턴트입니다 ✈️\n여행에 대해 무엇이든 물어보세요!', off: '관광지, 일정, 교통, 숙박, 비자, 음식, 문화, 예산, 날씨, 환전, 유심/eSIM, 짐·환승, 여행자 보험, 현지 에티켓, 긴급 상황, 쇼핑·세금 환급 등 여행 관련 질문에 답변합니다. 여행과 관련된 실용적인 질문은 모두 여행 관련으로 간주하세요. 명백히 무관한 질문(시, 코딩, 숙제 등)만 정중히 거절하세요.', factCheck: '비자, 운영시간, 요금 등 자주 바뀌는 정보는 단정하지 말고 공식 최신 정보를 확인하도록 안내하세요. 날씨 질문은 여행 질문이므로 절대 거절하지 마세요. 실시간 예보는 없으므로 해당 지역·월의 일반적인 기후(기온, 강수, 복장)를 알려주고 월 단위의 대략적인 범위만(예: "약 15~22°C") 사용하고 일별 수치나 강수 확률은 쓰지 말며, 실시간 예보가 아님을 명시하세요.', disclaimer: '참고용 정보입니다. 비자/운영시간/요금은 반드시 직접 확인하세요' },
};
const getLangCfg = (lang) => LANG_CONFIG[lang] || LANG_CONFIG['zh-HK'];

const cleanAIText = (s) => {
  if (!s) return s;
  return s
    .replace(/�/g, '')
    .replace(/[■-◿]/g, '')
    .replace(/[☀-⛿]/g, '')
    .replace(/[✀-➿]/g, '')
    .replace(/[⬀-⯿]/g, '')
    .replace(/[•·∙†‡§¶※◎]/g, '')
    .replace(/[\u{1F300}-\u{1F5FF}]/gu, '')
    .replace(/[\u{1F600}-\u{1F64F}]/gu, '')
    .replace(/[\u{1F680}-\u{1F6FF}]/gu, '')
    .replace(/[\u{1F900}-\u{1FAFF}]/gu, '')
    .replace(/\s{2,}/g, ' ')
    .trim();
};
const buildSystemPrompt = (lang) => {
  const c = getLangCfg(lang);
  return `You are ${c.name}, a professional travel assistant for EC Travel. ${c.off} ${c.factCheck} ${c.sys}`;
};

async function callGroq(messages, lang = 'zh-HK') {
  const groqMessages = [
    { role: 'system', content: buildSystemPrompt(lang) },
    ...messages.map(m => ({
      role: m.role === 'user' ? 'user' : 'assistant',
      content: m.text,
    })),
  ];

  const res = await fetch('/api/groq', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      model: 'openai/gpt-oss-120b',
      messages: groqMessages,
      max_tokens: 1024,
    }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err?.error?.message || `HTTP ${res.status}`);
  }

  const data = await res.json();
  return data.choices?.[0]?.message?.content || '抱歉，無法取得回應。';
}

const SpeechRecognitionAPI = typeof window !== 'undefined'
  ? (window.SpeechRecognition || window.webkitSpeechRecognition)
  : null;

export default function TravelChatbot({ open: openProp, onToggle, lang = 'zh-HK' }) {
  const [openLocal, setOpenLocal] = useState(false);
  const open = openProp !== undefined ? openProp : openLocal;
  const setOpen = onToggle || setOpenLocal;
  const [messages, setMessages] = useState(() => [
    { role: 'bot', text: getLangCfg(lang).welcome }
  ]);
  // Reset welcome message when language changes
  const prevLang = useRef(lang);
  useEffect(() => {
    if (prevLang.current !== lang) {
      prevLang.current = lang;
      setMessages([{ role: 'bot', text: getLangCfg(lang).welcome }]);
    }
  }, [lang]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [listening, setListening] = useState(false);
  const [voiceLang, setVoiceLang] = useState('zh-HK');
  const bottomRef = useRef(null);
  const recognitionRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, open]);

  const stopListening = useCallback(() => {
    recognitionRef.current?.stop();
    recognitionRef.current = null;
    setListening(false);
  }, []);

  const startListening = useCallback(() => {
    if (!SpeechRecognitionAPI) return;
    if (listening) { stopListening(); return; }

    const recognition = new SpeechRecognitionAPI();
    recognition.lang = voiceLang;
    recognition.continuous = false;
    recognition.interimResults = true;

    recognition.onstart = () => setListening(true);

    recognition.onresult = (e) => {
      const transcript = Array.from(e.results)
        .map(r => r[0].transcript)
        .join('');
      setInput(transcript);
    };

    recognition.onend = () => {
      setListening(false);
      recognitionRef.current = null;
    };

    recognition.onerror = () => {
      setListening(false);
      recognitionRef.current = null;
    };

    recognitionRef.current = recognition;
    recognition.start();
  }, [listening, voiceLang, stopListening]);

  // Clean up on unmount
  useEffect(() => () => stopListening(), [stopListening]);

  async function sendMessage() {
    const text = input.trim();
    if (!text || loading) return;
    if (listening) stopListening();
    const next = [...messages, { role: 'user', text }];
    setInput('');
    setMessages(next);
    setLoading(true);
    try {
      const reply = cleanAIText(await callGroq(next, lang));
      setMessages(prev => [...prev, { role: 'bot', text: reply }]);
    } catch (err) {
      console.error('GROQ chatbot error:', err.message);
      setMessages(prev => [...prev, { role: 'bot', text: `錯誤：${err.message}` }]);
    }
    setLoading(false);
  }

  function handleKey(e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); }
  }

  const langOptions = [
    { value: 'zh-HK', label: '粵' },
    { value: 'zh-CN', label: '普' },
    { value: 'en-US', label: 'EN' },
  ];

  return (
    <>
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          position: 'fixed', bottom: 24, right: 24, zIndex: 9999,
          width: 56, height: 56, borderRadius: '50%',
          background: 'linear-gradient(135deg,#f59e0b,#d97706)',
          border: 'none', cursor: 'pointer',
          boxShadow: '0 4px 20px rgba(245,158,11,0.5)',
          display: openProp !== undefined ? 'none' : 'flex',
          alignItems: 'center', justifyContent: 'center',
          fontSize: 24, transition: 'transform 0.2s',
        }}
        onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.1)'}
        onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
        title="EC 旅遊小助手"
      >
        {open ? '✕' : '✈️'}
      </button>

      {open && (
        <div style={{
          position: 'fixed', bottom: 90, right: 24, zIndex: 9998,
          width: 340, height: 480, borderRadius: 16,
          background: '#fff', boxShadow: '0 8px 40px rgba(0,0,0,0.18)',
          display: 'flex', flexDirection: 'column', overflow: 'hidden',
          fontFamily: "'Segoe UI',sans-serif",
        }}>
          {/* Header */}
          <div style={{
            padding: '14px 16px',
            background: 'linear-gradient(135deg,#f59e0b,#d97706)',
            color: '#fff', display: 'flex', alignItems: 'center', gap: 10,
          }}>
            <span style={{ fontSize: 20 }}>✈️</span>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: 14 }}>EC 旅遊小助手</div>
              <div style={{ fontSize: 11, opacity: 0.85 }}>只回答旅遊相關問題</div>
            </div>
            {/* Voice language selector */}
            {SpeechRecognitionAPI && (
              <div style={{ display: 'flex', gap: 3 }}>
                {langOptions.map(opt => (
                  <button key={opt.value} onClick={() => setVoiceLang(opt.value)}
                    title={`語音語言：${opt.label}`}
                    style={{
                      fontSize: 9, fontWeight: 900, padding: '2px 5px', borderRadius: 5, border: 'none', cursor: 'pointer',
                      background: voiceLang === opt.value ? 'rgba(255,255,255,0.35)' : 'rgba(255,255,255,0.15)',
                      color: '#fff',
                    }}>
                    {opt.label}
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Messages */}
          <div style={{
            flex: 1, overflowY: 'auto', padding: '12px 12px 4px',
            display: 'flex', flexDirection: 'column', gap: 8,
          }}>
            {messages.map((m, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: m.role === 'user' ? 'flex-end' : 'flex-start' }}>
                <div style={{
                  maxWidth: '80%', padding: '8px 12px', borderRadius: 12,
                  fontSize: 13, lineHeight: 1.6, whiteSpace: 'pre-wrap',
                  background: m.role === 'user' ? 'linear-gradient(135deg,#f59e0b,#d97706)' : '#f1f5f9',
                  color: m.role === 'user' ? '#fff' : '#1e293b',
                  borderBottomRightRadius: m.role === 'user' ? 4 : 12,
                  borderBottomLeftRadius: m.role === 'bot' ? 4 : 12,
                }}>
                  {m.text}
                </div>
              </div>
            ))}
            {loading && (
              <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                <div style={{ background: '#f1f5f9', borderRadius: '12px 12px 12px 4px', padding: '8px 14px', color: '#94a3b8' }}>
                  •••
                </div>
              </div>
            )}
            <div ref={bottomRef} />
          </div>

          <div style={{ padding: '0 12px', fontSize: 9, color: '#94a3b8', textAlign: 'center' }}>{getLangCfg(lang).disclaimer}</div>

          {/* Input area */}
          <div style={{ padding: '10px 12px', borderTop: '1px solid #e2e8f0', display: 'flex', gap: 6, alignItems: 'flex-end' }}>
            {/* Mic button */}
            {SpeechRecognitionAPI && (
              <button onClick={startListening} title={listening ? '停止錄音' : '語音輸入'}
                style={{
                  width: 36, height: 36, borderRadius: 10, border: 'none', flexShrink: 0, cursor: 'pointer',
                  background: listening ? 'linear-gradient(135deg,#ef4444,#dc2626)' : '#f1f5f9',
                  color: listening ? '#fff' : '#64748b',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16,
                  animation: listening ? 'pulse 1s ease-in-out infinite' : 'none',
                }}>
                {listening ? '⏹' : '🎤'}
              </button>
            )}
            <textarea
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={handleKey}
              placeholder={listening ? '聆聽中…' : '輸入旅遊問題...'}
              rows={1}
              style={{
                flex: 1, resize: 'none', border: `1.5px solid ${listening ? '#ef4444' : '#e2e8f0'}`,
                borderRadius: 10, padding: '8px 10px', fontSize: 13,
                fontFamily: 'inherit', outline: 'none', lineHeight: 1.5, maxHeight: 80, overflowY: 'auto',
              }}
              onFocus={e => e.target.style.borderColor = listening ? '#ef4444' : '#f59e0b'}
              onBlur={e => e.target.style.borderColor = listening ? '#ef4444' : '#e2e8f0'}
            />
            <button
              onClick={sendMessage}
              disabled={loading || !input.trim()}
              style={{
                width: 36, height: 36, borderRadius: 10, border: 'none', flexShrink: 0,
                background: loading || !input.trim() ? '#e2e8f0' : 'linear-gradient(135deg,#f59e0b,#d97706)',
                color: loading || !input.trim() ? '#94a3b8' : '#fff',
                cursor: loading || !input.trim() ? 'default' : 'pointer',
                fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}
            >➤</button>
          </div>
        </div>
      )}
    </>
  );
}
